import type { SVGProps } from "react";
export interface WifiOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WifiOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WifiOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.233 8.66a11.1 11.1 0 0 1 4.728 2.992 1.126 1.126 0 0 1-1.636 1.544 8.84 8.84 0 0 0-3.77-2.39l.34-1.073zm-1.413.733c.188-.592.82-.92 1.413-.734l-.679 2.146a1.126 1.126 0 0 1-.734-1.412m-3.692-5.396c4.384-.57 8.945.87 12.363 4.287l.328.337.075.088a1.126 1.126 0 0 1-1.63 1.535l-.083-.079-.28-.288c-2.921-2.923-6.787-4.13-10.483-3.65a1.126 1.126 0 0 1-.29-2.23m2.089 12.888a2.126 2.126 0 1 1-2.332 2.332l-.01-.216.01-.219A2.126 2.126 0 0 1 12 16.875zM1.704 2.205a1.126 1.126 0 0 1 1.506-.078l.085.078 17 17 .077.086a1.124 1.124 0 0 1-1.582 1.582l-.085-.078-6.054-6.053c-1.451-.206-2.982.28-4.118 1.484a1.126 1.126 0 0 1-1.638-1.544 7.06 7.06 0 0 1 3.624-2.071l-1.612-1.613a8.9 8.9 0 0 0-3.232 2.197 1.124 1.124 0 1 1-1.636-1.542c.942-1 2.014-1.788 3.163-2.36l-1.46-1.46a13.1 13.1 0 0 0-2.923 2.332l-.084.08a1.126 1.126 0 0 1-1.554-1.623l.485-.492a15.4 15.4 0 0 1 2.439-1.934l-2.401-2.4-.076-.086a1.125 1.125 0 0 1 .076-1.505"
      />
    </svg>
  );
}
